import h from 'virtual-dom/h';
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import {VNode} from "virtual-dom";
import {DisplayLink} from "@alme/types/response/DisplayLink";
import {HistoryMessageAlme} from "../../../../types/history";
import {Dictionary, Mutator} from "../../../../types/rendering";
import {Input} from "../../../../types/input";
import {enableInputBox, disableInputBox, SendRequestAndReEnableInputBox} from '../../../lib-inputbox-toggle/lib/lib-inputbox-toggle';

export default class UnitLinkBuilder
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _linkMutators: Mutator[] = [];


    //#region Public Interface

    constructor(settings: DefaultSettings, linkMutatorModules: Mutator[] = [])
    {
        this._settings = settings;
        this._linkMutators = linkMutatorModules;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    buildUnitLink(link: DisplayLink, shouldEnableInputBox: boolean, message: HistoryMessageAlme, index: number): VNode[]
    {
        const { displayLinkDisabled, unitDisplayLink } = this._settings.classNames;
        const shouldDisable = this._store?.getState().Window.DisplayLinks.shouldDisable as boolean;
        const properties = { className : shouldDisable ? displayLinkDisabled : unitDisplayLink };

        return [h('div', properties, [this.buildLink(link, shouldEnableInputBox, message, index, shouldDisable)])];
    }

    //#endregion



    //#region Helper Methods

    buildLink(link: DisplayLink, shouldEnableInputBox: boolean, message: HistoryMessageAlme, index: number, shouldDisable: boolean): VNode
    {
        const linkId = `${message.extensionData.entryId}-dispLink${index}`;

        let params: Dictionary = shouldDisable
        ? {}
        : { attributes: {href : '#', id: linkId}, onclick : this.buildLinkOnClick(link, shouldEnableInputBox, linkId)};

        params = this._linkMutators.reduce((props, mutate) => mutate(props), params)

        return h('a', params, link.DisplayText);
    }

    buildLinkOnClick(link, shouldEnableInputBox, linkId)
    {
        return (e: Event): boolean =>
        {
            const input: Input =
            {
                unitId: link.Metadata.UnitUID,
                displayText: link.DisplayText,
                origin: 'Click',
                messageType: this._settings.messageConstants.requestUnitRequest,
                parameters: {
                    UnitRequestMetadata: link.Metadata,
                    LinkId: linkId,
                    SelectedDisplayLinkName: link.DisplayText,
                },
            };
            disableInputBox(this._store, this._settings, () => true);
            SendRequestAndReEnableInputBox(input, this._store, this._settings)
            e.preventDefault();
            

            return false;
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-display-links/src/builders/linkUnitBuilder.ts